import { FC } from 'react';
import clsx from 'clsx';
import styles from '../styles.module.css';
import { navGroups } from '../../../routes/config';
import SidebarGroup from './group';

// eslint-disable-next-line arrow-body-style
const Sidebar: FC = () => {

  return (
    <div className={clsx('is-hidden-touch', styles.sidebarWrapper)}>
      <aside className="menu">

        {navGroups.map((navGroup, i) => (
          <SidebarGroup key={i} group={navGroup.group} routes={navGroup.routes} />
        ))}
        
      </aside>
    </div>
  );

};

export default Sidebar;
